import { getConfig } from "../_configs/AppConfig";

export function dataURItoFile(dataurl: string, filename: string | null) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)![1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], String(filename), { type: mime });
}

export function buildIconUrl(s3Key: string, size: number) {
  const { publicRuntimeConfig } = getConfig();

  const iconUrl = JSON.stringify({
    bucket: publicRuntimeConfig.S3_MEDIA_BUCKET,
    key: s3Key,
    edits: {
      resize: {
        width: size,
        height: size,
        fit: "cover",
      },
    },
  });
  return (
    publicRuntimeConfig.IMAGE_HANDLER_URL +
    "/" +
    Buffer.from(iconUrl).toString("base64")
  );
}
